// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"8df38326","618":"c26e535d"}[chunkId] + ".chunk.css";
};